import * as React from 'react';
import { TinTucService } from '../../services'
import { NEWS } from '../../const/seo-url';
import { formatUrlSeo } from '../../util/seo-url';
import { DANH_MUC } from '../../const/danh-muc';
export default class extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tinTucLienQuan: [],
      loading: false
    }
  }

  componentDidMount() {
    TinTucService.getsNewsLienQuanByID(this.props.tin_tuc_id, 9)
      .then(value => {
        let danhmuc = 0;
        if (this.props.danh_muc != null)
          danhmuc = this.props.danh_muc;
        if (value && value.length > 0) {
          value.forEach(x => {
            x['url_seo_tin'] = formatUrlSeo(x['url'], x['id']);
          });
        }
        this.setState({
          tinTucLienQuan: value,
          loading: true,
          danhmuc: danhmuc
        })

      })
  }

  render() {
    return (
      <div>
        {this.state.tinTucLienQuan && this.state.loading && this.state.tinTucLienQuan.length > 0 ? (
          <React.Fragment>
            <hr />
            <div className="extranews_box">
              <h4><strong>Tin liên quan</strong></h4>
              <div className="extranews_older">
                <ul className="older">

                  {this.state.tinTucLienQuan.map((tinTuc, index) => {
                    if (this.state.danhmuc == DANH_MUC.TUYEN_DUNG) {
                      return <li key={index} className="">
                        <a href={`/${NEWS.TUYEN_DUNG}/${tinTuc['url_seo_tin']}`}>{tinTuc['tieuDe']}</a>
                      </li>
                    } else if (this.state.danhmuc == DANH_MUC.MEGESTORY) {
                      return <li key={index} className="">
                        <a href={`/${NEWS.MEGASTORY}/${tinTuc['url_seo_tin']}`}>{tinTuc['tieuDe']}</a>
                      </li>
                    } else {
                      return <li key={index} className="">
                        <a href={`/${NEWS.TIN_TUC}/${tinTuc['url_seo_tin']}`}>{tinTuc['tieuDe']}</a>
                      </li>
                    }
                  })}
                </ul>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </div>
    )
  }
}
